import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getOtherCoursesCategory} from '../../actions';
import CoursesListItem from "../List/CoursesListItem";

class OtherCoursesCategory extends Component {
    componentDidMount() {
        const {idCategory, idCourse} = this.props;

        this.props.getOtherCoursesCategory(idCategory, idCourse);
    }

    render() {
        const {courses, loading} = this.props;

        if (courses !== null && courses.posts && (Array.isArray(courses.posts) && courses.posts.length > 0) && !loading) {
            return (
                <aside id="other-courses-list">
                    <div className="row">
                        {courses.posts.map(course => (
                            <CoursesListItem key={course.id} course={course}/>
                        ))}
                    </div>
                </aside>
            );
        }

        return null;
    }
}

OtherCoursesCategory.propTypes = {
    idCategory: PropTypes.number.isRequired,
    idCourse: PropTypes.number.isRequired,
    getOtherCoursesCategory: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    courses: state.courses.otherCoursesCategory,
    loading: state.courses.otherCoursesCategoryLoading,
    errors: state.errors,
});

export default withRouter(connect(mapStateToProps, {getOtherCoursesCategory})(OtherCoursesCategory));


// WEBPACK FOOTER //
// ./src/features/Courses/components/Details/OtherCoursesCategory.js